import httpService from '@/modules/common/services/httpService';

const baseRoute = '/v2/dashboard/calendar';

const getCalendarSummary = async (staffTeamsViewState) => httpService.get(`${baseRoute}?teams_view_filter=${staffTeamsViewState}`).then((res) => res.data);

export default {
  getCalendarSummary,
};
